import { usePostMutation } from "@/api/swr/useMutation";
import { z } from "zod";

type Config = Parameters<typeof usePostMutation<z.ZodUndefined, z.ZodNull>>[3];

export const useMarkAsChecked = (id: string, config?: Config) => {
  return usePostMutation(
    z.undefined(),
    z.null(),
    `/console/pending_assessments/answer_sub_categories/${id}/mark_as_checked`,
    config,
  );
};
